import { render, staticRenderFns } from "./viewImage.vue?vue&type=template&id=20107eb7&scoped=true"
import script from "./viewImage.vue?vue&type=script&lang=js"
export * from "./viewImage.vue?vue&type=script&lang=js"
import style0 from "./viewImage.vue?vue&type=style&index=0&id=20107eb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20107eb7",
  null
  
)

export default component.exports